import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_CMS_LIST, MANAGE_CMS_ADD, MANAGE_CMS_VIEW, MANAGE_CMS_EDIT, MANAGE_CMS_DELETE, MANAGE_CMS_DELETE_RESOURCE, MANAGE_CMS_ARCHIVE } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const cmsApi = createApi({

    reducerPath: 'cmsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/cms",
    }),
    tagTypes: ["CmsList", "CmsDetails"],
    endpoints: (builder) => ({

        // get cms list
        getCmsList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "desc" } }) => ({
                method: "PATCH",
                url: MANAGE_CMS_LIST,
                data: { search, status, page, limit, sort, },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["CmsList"]
        }),

        // get cms data
        getCmsDetail: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_CMS_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["CmsDetails"]
        }),

        // create cms
        createCms: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_CMS_ADD,
                data
            }),
            invalidatesTags: ["CmsList"]
        }),

        // update cms
        updateCms: builder.mutation({
            query: ({ data, contentId }) => ({
                method: "PUT",
                url: `${MANAGE_CMS_EDIT}/${contentId}`,
                data
            }),
            invalidatesTags: ["CmsList", "CmsDetails"]
        }),

        // delete cms
        deleteCms: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_CMS_DELETE}/${id}`
            }),
            invalidatesTags: ["CmsList", "CmsDetails"]
        }),

        // delete cms resource
        deleteCmsResource: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_CMS_DELETE_RESOURCE}/${id}`
            }),
            invalidatesTags: ["CmsDetails"]
        }),

        // archive cms
        archiveCms: builder.mutation({
            query: (id) => ({
                method: "PUT",
                url: `${MANAGE_CMS_ARCHIVE}/${id}`
            }),
            invalidatesTags: ["CmsList", "CmsDetails"]
        }),
    }),
})

export const {

    useGetCmsListQuery,
    useGetCmsDetailQuery,
    useCreateCmsMutation,
    useDeleteCmsMutation,
    useDeleteCmsResourceMutation,
    useUpdateCmsMutation,
    useArchiveCmsMutation

} = cmsApi;